import { ReactRenderer } from "@tiptap/react";
import tippy from "tippy.js";
import axios from "axios";
import MentionList from "./MentionList";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ENTITY_ROUTE_MAP = {
  character: "character",
  npc: "npc",
  creature: "creature",
  location: "location",
  lore: "lore",
  deity: "deity",
  item: "item",
};

// Debounced async search. Returns items shaped { id, name, type, href }
export const buildMentionSuggestion = (getCampaignId) => {
  let abortController = null;

  return {
    char: "@",
    allowSpaces: false,
    startOfLine: false,

    items: async ({ query }) => {
      const campaignId = getCampaignId();
      if (!campaignId || !query || query.length < 1) return [];

      // Cancel any in-flight request
      if (abortController) abortController.abort();
      abortController = new AbortController();

      try {
        const res = await axios.get(`${API}/campaigns/${campaignId}/search`, {
          params: { q: query },
          withCredentials: true,
          signal: abortController.signal,
        });
        return (res.data || []).slice(0, 8).map((r) => ({
          id: r.id,
          name: r.name,
          type: r.type,
          href: `/campaign/${campaignId}/${ENTITY_ROUTE_MAP[r.type] || r.type}/${r.id}`,
        }));
      } catch (e) {
        if (axios.isCancel?.(e) || e?.code === "ERR_CANCELED") return [];
        return [];
      }
    },

    render: () => {
      let reactRenderer;
      let popup;

      return {
        onStart: (props) => {
          reactRenderer = new ReactRenderer(MentionList, {
            props: { ...props, loading: false },
            editor: props.editor,
          });

          if (!props.clientRect) return;

          popup = tippy("body", {
            getReferenceClientRect: props.clientRect,
            appendTo: () => document.body,
            content: reactRenderer.element,
            showOnCreate: true,
            interactive: true,
            trigger: "manual",
            placement: "bottom-start",
            theme: "natone-mention",
            arrow: false,
            offset: [0, 6],
          });
        },

        onUpdate: (props) => {
          reactRenderer?.updateProps(props);
          if (!props.clientRect) return;
          popup?.[0]?.setProps({ getReferenceClientRect: props.clientRect });
        },

        onKeyDown: (props) => {
          if (props.event.key === "Escape") {
            popup?.[0]?.hide();
            return true;
          }
          return reactRenderer?.ref?.onKeyDown?.(props) || false;
        },

        onExit: () => {
          popup?.[0]?.destroy();
          reactRenderer?.destroy();
        },
      };
    },
  };
};
